// Device-tier quality settings, decided once at load. Touch-primary
// devices (phones/tablets) get the mobile tier: the game is fill-rate and
// vertex bound, so the levers are render resolution, MSAA, cloud raymarch
// depth, and grass density/draw distance. (hover: none) and (pointer:
// coarse) is true for touchscreens but false for desktops - including
// touchscreen laptops that also have a mouse/trackpad.
// ?touch forces the mobile tier on desktop, for previewing the joysticks
// and mobile quality settings without a phone.
export const IS_MOBILE =
    window.matchMedia('(hover: none) and (pointer: coarse)').matches ||
    new URLSearchParams(window.location.search).has('touch');

// Phones with devicePixelRatio 3 would otherwise push 9x the pixels of a
// 1x display through the HalfFloat pipeline; 1.5 keeps the image crisp on
// a small screen at half the fragment cost of the desktop cap.
export const PIXEL_RATIO_CAP = IS_MOBILE ? 1.5 : 2;

// MSAA on the HDR buffer: grass shimmer control. 2x reads nearly as well
// as 4x at phone pixel densities and halves the resolve bandwidth.
export const MSAA_SAMPLES = IS_MOBILE ? 2 : 4;

// (Cloud raymarch depth is tiered per-device where the sky material is
// built - render-sky-component.js - via its defines block.)

// Screen-space god ray gather taps (threejs-component.js).
export const GODRAY_SAMPLES = IS_MOBILE ? 32 : 48;

// Grass: instance density per patch, and how far real blades reach.
export const GRASS_DENSITY_SCALE = IS_MOBILE ? 0.5 : 1.0;
export const GRASS_MAX_DIST = IS_MOBILE ? 150 : 225;
